var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOngoingMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9102 25.4133C37.1593 24.7978 37.5864 24.2708 38.137 23.8996C38.6875 23.5285 39.3363 23.3302 40.0002 23.3302C40.6642 23.3302 41.313 23.5285 41.8635 23.8996C42.4141 24.2708 42.8412 24.7978 43.0903 25.4133C45.5553 26.0904 47.7297 27.5583 49.2792 29.5914C50.8288 31.6246 51.6676 34.1104 51.6669 36.6667V44.495L54.7203 49.075C54.8877 49.326 54.9839 49.6177 54.9985 49.9191C55.0132 50.2205 54.9457 50.5202 54.8034 50.7863C54.661 51.0523 54.4491 51.2747 54.1903 51.4298C53.9314 51.5848 53.6353 51.6667 53.3336 51.6667H45.7752C45.5746 53.0552 44.8804 54.3249 43.8198 55.2432C42.7591 56.1616 41.4032 56.667 40.0002 56.667C38.5973 56.667 37.2413 56.1616 36.1807 55.2432C35.1201 54.3249 34.4259 53.0552 34.2252 51.6667H26.6669C26.3652 51.6667 26.0691 51.5848 25.8102 51.4298C25.5514 51.2747 25.3395 51.0523 25.1971 50.7863C25.0548 50.5202 24.9873 50.2205 25.002 49.9191C25.0166 49.6177 25.1128 49.326 25.2802 49.075L28.3336 44.495V36.6667C28.3336 31.2933 31.9669 26.7667 36.9102 25.4133ZM37.6436 51.6667C37.8157 52.1544 38.1349 52.5768 38.5571 52.8755C38.9794 53.1742 39.4839 53.3347 40.0011 53.3347C40.5183 53.3347 41.0228 53.1742 41.445 52.8755C41.8673 52.5768 42.1865 52.1544 42.3586 51.6667H37.6436ZM40.0002 28.3333C37.7901 28.3333 35.6705 29.2113 34.1077 30.7741C32.5449 32.3369 31.6669 34.4565 31.6669 36.6667V45C31.667 45.3292 31.5696 45.6511 31.3869 45.925L29.7819 48.3333H50.2169L48.6119 45.925C48.4299 45.6509 48.333 45.329 48.3336 45V36.6667C48.3336 34.4565 47.4556 32.3369 45.8928 30.7741C44.33 29.2113 42.2104 28.3333 40.0002 28.3333Z",
    fill: "url(#paint0_linear_1375_2679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1375_2679",
    x1: 25,
    y1: 39.9986,
    x2: 55.0005,
    y2: 39.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingMonitoring);
export default __webpack_public_path__ + "static/media/Ongoing Monitoring.fb2d25234bdb057c9ee7dd18cbda7999.svg";
export { ForwardRef as ReactComponent };